module.exports = __webpack_public_path__ + "static/ObjectSans-HeavySlanted-1e634ffeee1e14fab5545612974f9841.otf";